// extracted by mini-css-extract-plugin
export default {"pageLayout":"JobProspectsStats-module__pageLayout___FK5h4"};